import { render, staticRenderFns } from "./DurationAndResignation.vue?vue&type=template&id=58af2652&"
import script from "./DurationAndResignation.vue?vue&type=script&lang=js&"
export * from "./DurationAndResignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/form/DurationAndResignation.vue
// module id = null
// module chunks = 